import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useRef, useState } from "react";

const DateInput = (props) => {
  const dateFormat = props?.showTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY";
  const toDateRef = useRef(null); // Ref for the "to" date picker

  // State to track the selected from date for validation
  const [fromDate, setFromDate] = useState(props.dateFrom ? dayjs(props.dateFrom, dateFormat) : null);

  const handleFromDateChange = (date, dateString) => {
    setFromDate(date); // Update local state
    if (props.onDateChange) {
      const currentTo = props.dateTo || null;
      props.onDateChange(dateString, currentTo);
    }
    // Automatically focus on the "to" date picker after selecting "from"
    if (toDateRef.current) {
      toDateRef.current.focus();
    }
  };

  const handleToDateChange = (date, dateString) => {
    if (props.onDateChange) {
      const currentFrom = props.dateFrom || null;
      props.onDateChange(currentFrom, dateString);
    }
  };

  // Disabled dates for "from": past dates
  const disabledFromDate = (current) => {
    return current && current < dayjs().startOf("day");
  };

  // Disabled dates for "to": past dates and dates before "from"
  const disabledToDate = (current) => {
    const today = dayjs().startOf("day");
    const isBeforeToday = current && current < today;
    const isBeforeFrom = fromDate && current && current < fromDate.startOf("day");
    return isBeforeToday || isBeforeFrom;
  };

  return (
    <div className="d-flex w-100 ">
      <div className="flex-fill me-2">
        <label className="form-label">{props.leftLabel}</label>
        <DatePicker
          className="input-blue w-100 p-range-date border rounded z-1"
          format={dateFormat}
          showTime={props.showTime}
          onChange={handleFromDateChange}
          placeholder={props.leftLabel}
          value={fromDate}
          disabledDate={disabledFromDate}
        />
      </div>
      <div className="flex-fill ms-2">
        <label className="form-label">{props.rightLabel}</label>
        <DatePicker
          ref={toDateRef}
          className="input-blue w-100 p-range-date border rounded z-1"
          format={dateFormat}
          showTime={props.showTime}
          onChange={handleToDateChange}
          placeholder={props.rightLabel}
          value={props.dateTo ? dayjs(props.dateTo, dateFormat) : null}
          disabledDate={disabledToDate}
        />
      </div>
    </div>
  );
};

export default DateInput;




// import { DatePicker } from "antd";
// import dayjs from "dayjs";
// const { RangePicker } = DatePicker;

// const DateInput = (props) => {
//   var dateFormat = "DD/MM/YYYY";
//   if (props?.showTime === true) {
//     dateFormat = "DD/MM/YYYY HH:mm";
//   }
//   const handleDateChange = (dates, dateStrings) => {
//     if (props.onDateChange) {
//       if (!dates) {
//         return;
//       }

//       props.onDateChange(dateStrings[0], dateStrings[1]);
//     }
//   };

//   const disabledDate = (current) => {
//     return current && current < dayjs().startOf("day");
//   };
//   return (
//     <RangePicker
//       className="input-blue w-100 p-range-date border rounded-0 z-1"
//       format={dateFormat}
//       showTime={props.showTime}
//       onChange={handleDateChange}
//       placeholder={[props.leftLabel, props.rightLabel]}
//       value={[
//         props.dateFrom ? dayjs(props.dateFrom, dateFormat) : null,
//         props.dateTo ? dayjs(props.dateTo, dateFormat) : null,
//       ]}
//     />
//   );
// };

// export default DateInput;
